import { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Line } from "react-chartjs-2";

interface propsType {
  chartData: any;
}

interface IGridCols {
  label: string;
  value: number;
}

Chart.register(CategoryScale);

const MonthltyKeywordChart = (props: propsType) => {
  return (
    <div className="chart-root">
      <Line
        data={props.chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
          scales: {
            x: {
              display: true,
            },
          },
        }}
      />
    </div>
  );
};

export default MonthltyKeywordChart;
